import styles from "./Indicator.module.css";

export default function Indicator({
  maxValue,
  value,
  doNotDisplayText = false,
}: {
  value: number;
  maxValue: number;
  doNotDisplayText?: boolean;
}) {
  let percentage;
  if (value) {
    percentage = Math.round((value / maxValue) * 100);
  } else {
    percentage = 0;
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        maxWidth: "100%",
      }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          maxWidth: "fit-content",
          minWidth: "fit-content",
          aspectRatio: "130 / 150",
        }}
      >
        <img
          src="/images/beer-empty.svg"
          style={{ height: "100%", zIndex: "2", position: "relative" }}
          alt=""
        />
        <div
          style={{
            position: "absolute",
            width: "61%",
            height: `70%`,
            bottom: "5.5%",
            left: "6%",
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          <div
            style={{
              width: "100%",
              height: `${percentage}%`,
              backgroundColor: "#efb541",
              zIndex: "1",
            }}
            className={styles["status-bar"]}
          ></div>
        </div>
        {!doNotDisplayText && (
          <>
            <div
              style={{
                position: "absolute",
                zIndex: "2",
                top: "6%",
                width: "73%",
                textAlign: "center",
                fontWeight: "bold",
                color: "black",
                fontSize: "1.5rem",
              }}
            >
              {value} ‰
            </div>
          </>
        )}
      </div>
    </div>
  );
}
